import { render } from "./addTest.vue?vue&type=template&id=fe83265a"
import script from "./addTest.vue?vue&type=script&lang=js"
export * from "./addTest.vue?vue&type=script&lang=js"

import "./addTest.vue?vue&type=style&index=0&id=fe83265a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__